<template>
    <AppModal ref="Modal" :title="$t('labels.products_export_modal')" @on-hide="hide">
        <div class="modal-body pb-0">
            <FormGroup :label="$t('labels.product_types')">
                <MultiAutoComplete
                    :url="`/projects/${$route.params.projectUuid}/pim/types`"
                    :model-value="categories"
                    @update:model-value="categories = $event"
                    option-key="uuid"
                    option-value="name"
                />
            </FormGroup>
        </div>
        <div class="modal-footer">
            <AppButton color="indigo" :disabled="submitting" @click="exportProducts">
                {{ $t('buttons.export') }}
            </AppButton>
        </div>
    </AppModal>
</template>
<script>
import AppModal from '../../../../../components/new/modal/AppModal.vue';
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import MultiAutoComplete from '../../../../../components/new/form/autocomplete/MultiAutoComplete.vue';
import AppButton from '../../../../../components/new/button/AppButton.vue';
import { httpClient } from '../../../../../services/HttpClient';
import MessageNotificator from '../../../../../services/MessageNotificator';

export default {
    name: 'ProductsExportModal',
    components: {
        AppModal, FormGroup, MultiAutoComplete, AppButton
    },
    emits: ['export:started'],
    data() {
        return {
            categories: [],
            submitting: false
        }
    },
    methods: {
        show() {
            this.$refs.Modal.show();
        },
        hide() {
            this.$refs.Modal.hide();
            this.categories = [];
            this.submitting = false;
        },
        async exportProducts() {
            if (this.submitting) {
                return;
            }

            this.submitting = true;

            try {
                await httpClient.post(
                    `/projects/${this.$route.params.projectUuid}/pim/products/export`,
                    { category_uuids: this.categories.map(category => category.uuid) }
                );

                new MessageNotificator().success(this.$t('alerts.starting_file_generation'));

                this.$emit('export:started');
                this.hide();
            } catch (e) {
                this.submitting = false;
            }
        }
    }
}
</script>
